/* eslint-disable no-nested-ternary */
import api from '@cannect/services/api'
import {
  formatDateBR,
  getCartSplitDeliveryEstimateTexts,
  orderHasPillItem,
  PILL_DELIVERY_CEP_TEXT
} from '@cannect/utils/deliveryEstimate'
import Banner from 'components/Banner'
import useMediaQuery from 'hooks/useMediaQuery'
import { usePrepareCart } from 'hooks/usePrepareCart'
import Button from 'new-components/Button'
import Heading from 'new-components/Heading'
import Modal from 'new-components/Modal'
import { useEffect, useState } from 'react'
import { FcApproval } from 'react-icons/fc'
import { useHistory } from 'react-router'
import { BRANDS_WITH_REQUIRED_FREIGHT, CLASS_WITHOUT_SHIPPING, MOBILE_WIDTH } from 'utils/constants'
import useQueryString from '../../hooks/useQueryString'
import Frete from './Frete'
import ProductList from './Product'
import { Resume } from './Resume'
import Step from './Steps'
import * as Style from './styles'
import { ContainerResume, ContentModal, WrapperModal } from './styles'

const formatEstimatedRangeText = (start?: string | null, end?: string | null) => {
  if (!start || !end) return null

  return `A entrega estimada é entre ${formatDateBR(start)} e ${formatDateBR(end)}.`
}

function PageCartProducts() {
  const isMobile = useMediaQuery(MOBILE_WIDTH)
  const { isUpdate, updateCart, lastOrderCreated, setOrderId, clearOrderData, validatingDeliveryCep } = usePrepareCart()
  const { filters } = useQueryString()
  const withFilter = filters?.cart_id
  const history = useHistory()
  const itens = lastOrderCreated?.items ?? []
  const noImportCost = lastOrderCreated?.noImportCost
  const isModalPayment = lastOrderCreated?.payments?.some((payment: any) => payment.status === 'paid')
  const [isModal, setIsModal] = useState(isModalPayment)
  const [isModalRecipeWarning, setIsModalRecipeWarning] = useState(false)

  const [openModalCupom, setCloseModalCupom] = useState(false)
  const userId = lastOrderCreated?.person?.id
  const modalRecipeWarningKey = '@CANNECT:RECIPE_WARNING'

  const isAllSupplements = itens.every(
    (item: any) =>
      CLASS_WITHOUT_SHIPPING.includes(item?.product?.class_id || item?.class_id) &&
      !BRANDS_WITH_REQUIRED_FREIGHT.includes(item?.product?.brand_id || item?.brand_id)
  )

  const isAllPill = itens.length > 0 && itens.every((item: any) => item?.product?.origin === 'pill')
  const cepAutoTriggerRef = useRef<string>('')

  const shippingRestriction =
    lastOrderCreated?.shipping_restriction ?? lastOrderCreated?.summary?.shipping_restriction ?? null
  const isDeliveryCovered = shippingRestriction === null || shippingRestriction?.covered !== false

  const handleCepChange = (value: string) => {
    const digits = (value || '').replace(/\D/g, '').slice(0, 8)
    const masked = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits
    setDeliveryCep(masked)
  }

  useEffect(() => {
    if (!withFilter) return
    const digits = String(lastOrderCreated?.cep || '').replace(/\D/g, '')
    if (digits.length !== 8) return
    // normalizeCep em usePrepareCart formata como "12345-678"; o ref deve guardar a mesma forma
    const normalized = `${digits.slice(0, 5)}-${digits.slice(5)}`
    if (cepAutoTriggerRef.current === normalized) return
    cepAutoTriggerRef.current = normalized
    setDeliveryCep(digits)
  }, [withFilter, isAllPill, lastOrderCreated?.cep])

  useEffect(() => {
    const target = cepAutoTriggerRef.current
    if (!target || deliveryCep !== target) return
    cepAutoTriggerRef.current = ''
    validateDeliveryCep()
  }, [deliveryCep])

  useEffect(() => {
    const getOrders = async () => {
      const { data } =
        !userId && !withFilter ? await api.get(`/order_last_paid`) : await api.get(`/order_last_paid/${userId}`)
      if (Object.keys(data.order).length === 0) {
        setCloseModalCupom(true)
      }
    }
    getOrders()
  }, [])

  useEffect(() => {
    if (isModalPayment) {
      localStorage.removeItem('@CANNECT:ORDER_CHECKOUT_CART_ID')
      setOrderId(null)
      clearOrderData()
    }
  })

  useEffect(() => {
    const oneHourInMilli = 60 * 60 * 1000
    const actualDateInMilli = Date.now()

    const stored = localStorage.getItem(modalRecipeWarningKey)
    const storedTs = stored ? parseInt(stored.replace(/"/g, ''), 10) : NaN

    if (!stored && !isAllSupplements) {
      setIsModalRecipeWarning(true)
    } else if (Number.isFinite(storedTs) && actualDateInMilli >= storedTs + oneHourInMilli && !isAllSupplements) {
      localStorage.removeItem(modalRecipeWarningKey)
      setIsModalRecipeWarning(true)
    }
  }, [isAllSupplements])

  const closeModalRecipeWarning = () => {
    const actualDateInMilli = Date.now()
    setIsModalRecipeWarning(false)
    localStorage.setItem(modalRecipeWarningKey, String(actualDateInMilli))
  }

  const closeModal = () => {
    setIsModal(false)
    if (withFilter) {
      history.push(`/analise-cannect-wa?cart_id=${withFilter}`)
    } else {
      history.push(`/analise-cannect`)
    }
  }

  const redirect = () => {
    if (withFilter) {
      history.push(`/documentos-wa?cart_id=${withFilter}`)
    } else {
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
          allow_custom_scripts: true,
          send_to: 'DC-15596039/invmedia/canne004+standard'
        })
      }

      handleNextCart()
    }
  }

  const goToProducts = () => {
    history.push(`/produtos/1`)
  }

  const handleNextCart = () => {
    const validateFlowers = itens.filter((item: any) => item?.product?.shape_id === 29)
    const produtosFormatados = itens
      .map((produto: any) => `*Produto:* ${produto.product?.id} - ${produto.product?.name}`)
      .join('\n')
    const numeroCliente = '5511982711992'

    if (validateFlowers.length > 0) {
      const mensagem = `Olá! Fui redirecionado porque gostaria de fazer um pedido que contém flores medicinais. Aqui está a lista dos produtos selecionados:\n${produtosFormatados}`
      const url = `https://api.whatsapp.com/send?phone=${numeroCliente}&text=${encodeURIComponent(mensagem)}`
      window.open(url, '_blank')
    } else {
      history.push('/documentos')
    }
  }

  const DISTRIBUTORS_HUB = [1, 7]

  const containsProductWithLongerDeliveryTime = itens.some(
    (item: any) => item?.product?.stock === 0 && DISTRIBUTORS_HUB.includes(item?.product?.distributor_id)
  )
  const containsProductWithHubDistributor = itens.some((item: any) =>
    DISTRIBUTORS_HUB.includes(item?.product?.distributor_id)
  )
  const containProductsMatirz = itens.some((item: any) => !DISTRIBUTORS_HUB.includes(item?.product?.distributor_id))
  const estimatedRangeText = formatEstimatedRangeText(
    lastOrderCreated?.estimated_delivery_range_start,
    lastOrderCreated?.estimated_delivery_range_end
  )
  const splitEstimateTexts = getCartSplitDeliveryEstimateTexts(lastOrderCreated)
  const hasPillItem = orderHasPillItem(lastOrderCreated)

  return (
    <Style.Container isMobile={isMobile}>
      <Step />
      <ProductList />
      {!isAllSupplements && (
        <>
          <Banner title="ATENÇÃO" variant="info">
            <p>
              Confira se o produto e a quantidade inseridos correspondem à sua prescrição médica. Você pode realizar uma
              compra parcial, mas não deve ultrapassar o limite máximo indicado na receita. Em caso de dúvidas, consulte
              seu médico.
            </p>
          </Banner>
          <Banner title="IMPORTANTE" variant="warning">
            {validatingDeliveryCep ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span className="delivery-estimate-spinner" />
                <p>Calculando estimativa de entrega...</p>
              </div>
            ) : splitEstimateTexts ? (
              splitEstimateTexts.map((text) => <p key={text}>{text}</p>)
            ) : estimatedRangeText ? (
              <p>{estimatedRangeText}</p>
            ) : hasPillItem ? (
              <p>{PILL_DELIVERY_CEP_TEXT}</p>
            ) : containsProductWithLongerDeliveryTime ? (
              <p>Existem produtos com possível maior tempo de entrega.</p>
            ) : containProductsMatirz ? (
              <p>O prazo de entrega é de 25 dias úteis a partir da confirmação do pagamento.</p>
            ) : containsProductWithHubDistributor ? (
              <p>O prazo de entrega é de 15 dias úteis a partir da confirmação do pagamento.</p>
            ) : null}
          </Banner>
        </>
      )}

      {withFilter && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: '16px 0' }}>
          <p style={{ fontWeight: 600, fontSize: 14, margin: 0 }}>CEP de entrega</p>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              type="text"
              placeholder="00000-000"
              maxLength={9}
              value={deliveryCep || ''}
              onChange={(e) => handleCepChange(e.target.value)}
              disabled={validatingDeliveryCep}
              style={{
                flex: 1,
                padding: '8px 12px',
                border: '1px solid #ccc',
                borderRadius: 4,
                fontSize: 14
              }}
            />
            <button
              type="button"
              onClick={validateDeliveryCep}
              disabled={validatingDeliveryCep || (deliveryCep || '').replace(/\D/g, '').length !== 8}
              style={{
                padding: '8px 16px',
                backgroundColor: '#6b7b3c',
                color: 'white',
                border: 'none',
                borderRadius: 4,
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 600,
                whiteSpace: 'nowrap',
                opacity: validatingDeliveryCep || (deliveryCep || '').replace(/\D/g, '').length !== 8 ? 0.5 : 1
              }}>
              {validatingDeliveryCep ? 'Validando...' : 'Validar CEP'}
            </button>
          </div>
        </div>
      )}

      {shippingRestriction?.covered === false && (
        <Banner title="ENTREGA INDISPONÍVEL" variant="negative">
          <p>Infelizmente não conseguimos realizar a entrega para o CEP informado.</p>
          {Array.isArray(shippingRestriction?.blocked_products) && shippingRestriction.blocked_products.length > 0 && (
            <ul style={{ marginTop: 4, paddingLeft: 16 }}>
              {shippingRestriction.blocked_products.map((p: any) => (
                <li key={p.product_id}>{p.name}</li>
              ))}
            </ul>
          )}
        </Banner>
      )}

      <ContainerResume isMobile={isMobile}>
        {lastOrderCreated?.origin !== 'REENVIO' && !noImportCost && <Frete />}
        <Resume />
      </ContainerResume>

      <Style.ButtonContainer>
        <Style.ButtonContinue onClick={redirect} disabled={isUpdate || itens.length <= 0 || !isDeliveryCovered}>
          {isUpdate ? 'Atualizando...' : 'Continuar'}
        </Style.ButtonContinue>
      </Style.ButtonContainer>
      <Modal isOpen={isModalRecipeWarning && !isModal} setOpenModal={closeModalRecipeWarning}>
        <WrapperModal>
          <Heading elementType="h2" defaultColor="darkGrey" fontSize="20px" verticalSpace="small">
            ATENÇÃO
          </Heading>
          <ContentModal>
            <p>
              Para finalizar o seu processo de importação, é necessário possuir uma prescrição médica emitida há menos
              de 5 meses. Caso não possua uma prescrição válida,{' '}
              <a
                style={{ color: 'rgb(107, 123, 60)', textDecoration: 'underline' }}
                href="https://api.whatsapp.com/send/?phone=5511982711992&text=Ol%C3%A1%2C+gostaria+de+agendar+uma+consulta+com+especialista+em+cannabis+medicinal%21+-+Inicie+a+conversa+para+ser+atendido&type=phone_number&app_absent=0">
                clique aqui
              </a>{' '}
              para falar conosco pelo WhatsApp
            </p>
            <Button onClick={() => closeModalRecipeWarning()}>CONTINUAR</Button>
          </ContentModal>
        </WrapperModal>
      </Modal>
      <Modal isOpen={isModal} setOpenModal={closeModal}>
        <WrapperModal>
          <FcApproval size={40} />
          <Heading elementType="h2" defaultColor="darkGrey" fontSize="20px" verticalSpace="small">
            Obrigado!
          </Heading>
          <ContentModal>
            <p>O seu pedido já foi processado e pago com sucesso.</p>
            <Button onClick={() => goToProducts()}>Buscar novos produtos</Button>
            <Button onClick={() => closeModal()}>Ver detalhes do pedido finalizado</Button>
          </ContentModal>
        </WrapperModal>
      </Modal>
    </Style.Container>
  )
}

export default PageCartProducts
